import Vue from 'vue'

function toCurrency(strNumber) {
  if (strNumber !== null || strNumber !== '') {
    strNumber = strNumber.replace(/[^\d]/g, '')
    let formatter = new Intl.NumberFormat('ko-KR', {
      minimumFractionDigits: 0
    })
    return formatter.format(strNumber)
  }
}
Vue.directive('currencyInput', {
  bind(el) {
    el.value = toCurrency(el.value)
  },
  update(el) {
    el.value = toCurrency(el.value)
  }
})
